<div class="topDiv" [style.background-color]="backgroundColorScreen" style="padding: 5px;">
    
    
  <div class="agGridOuterDiv">
    <div>
      <div>

        <div class="row topRowMargins headerStyle">

          <div class="dataset col-lg-12" style="margin-top: 1%;">
            Mapping Test Bed
          </div>

        </div>

      </div>


























  

      <!-- <div> -->


          <mat-toolbar class="agGridtoperDiv card" style="background: rgb(244 243 245);border-top: 1px solid #a9a9a9a8;border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">

             <label i18n="@@spmsUserReg" class="textColour">Mapping Test Bed</label>
              <span class="example-spacer"></span>
              

                 <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Create Test-Bed" (click) = "Createtestbed()" [disabled]="isdisable" id="114">
                  Create Test-Bed
                 </button>
                  <button class="refreshrunButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refreshh()">
                      Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                  </button>
                  
                  <div class="insertPageNoDiv">
                      <mat-form-field appearance="outline">
                          <mat-label i18n="@@Targetpageno">Page No</mat-label>
                          <input matInput type="text" (input)="onRunSearchChange($event.target.value)">
                      </mat-form-field>
                  </div>
                  <div class="selectRecordsDiv" style="width:9.5%">
                      <mat-form-field appearance="outline" style="width:100%">
                          <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                          <mat-select  [(ngModel)]="RunpageSize1"  (ngModelChange)="onRunPageSizeChanged(value)">
                              <mat-option value="10" selected>10</mat-option>
                              <mat-option value="200">200</mat-option>
                              <mat-option value="300">300</mat-option>
                              <mat-option value="400">400</mat-option>
                          </mat-select>

                      </mat-form-field>
                  </div>
                  <div class="card pagination paginationFirstButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onRunBtFirst1()"></em>
                  </div>
                  <div class="card pagination paginationButtons btn-rounded">
                      <ul>
                          <li class="paginationliicon">
                              <em class="fas fa-angle-left waves-effect waves-light" (click)="onRunBtPrevious1()"></em>
                          </li>
                          <li>{{RuncurrentPage1}}/{{RuntotalPages1}}</li>
                          <li class="paginationliicon" style="padding:0;">
                              <em class="fas fa-angle-right waves-effect waves-light" (click)="onRunBtNext1()"></em>
                          </li>
                      </ul>
                  </div>
                  <div class="card pagination paginationLastButton paginationFirstlastButton">
                      <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onRunBtLast1()"></em>
                  </div>

          </mat-toolbar>
      

          <div>

              
            
            <div>
              <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" 
              [columnDefs]="columnDefsExtractTemp" 
              [animateRows]="true"  
              [pagination]="true" 
              [rowSelection]="rowSelection" 
              [defaultColDef]="defaultColDef" 
              [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" 
              [enableBrowserTooltips]="true" 
              [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" 
              [paginationNumberFormatter]="paginationNumberFormatter" 
              [enableRangeSelection]="true" [debug]="true" 
              [rowClassRules]="rowClassRules" 
              (paginationChanged)="onloadPaginationChanged1()" 
              [components]="components"  
              (gridReady)="retrieveInstructionsBasedOnActivity($event)" 
              [hidden]="!true">

              </ag-grid-angular> 
            </div>

          </div>

  






</div>